{
  "defaultTitle": "无法完成签到",
  "defaultMessage": "请与您的调度员核实信息，或联系仓库",
  "backToHomescreen": "返回首页",
  "hideErrorLog": "隐藏错误日志",
  "viewErrorLog": "查看错误日志",
  "errorLogMessageLabel": "信息：",
  "errorLogStatusLabel": "状态代码：",
  "unknown": "未知"
}
